(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrap-price-calculator"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('wrap-price-calculator')) {
 class WrapPriceCalculator extends HTMLElement {
  connectedCallback() {
   if(this.ready)return;this.ready=true;
   this.catalogue=JSON.parse(this.querySelector('[data-catalogue]').textContent);
   this.words=JSON.parse(this.querySelector('[data-words]').textContent);
   this.vehicleCategories=JSON.parse(this.querySelector('[data-vehicle-categories]').textContent);
   this.vehicleBodies=JSON.parse(this.querySelector('[data-vehicle-bodies]').textContent);
   this.yearBodyRules=JSON.parse(this.querySelector('[data-year-body-rules]').textContent);
   this.bodyBands={"small_hatchback":"small_hatchback","hatchback":"hatchback","estate":"sedan","saloon":"sedan","luxury_saloon":"luxury_sedan","coupe":"hatchback","convertible":"hatchback","suv":"four_by_four","compact_mpv":"sedan","mpv":"four_by_four"};
   this.materialMetres={small_hatchback:13.5,hatchback:16.5,estate:24,saloon:21,luxury_saloon:24,coupe:18,convertible:19,suv:24,compact_mpv:20,mpv:24};
   this.bodyEdited=false;
   this.currency=JSON.parse(this.querySelector('[data-wrap-currency]').textContent);
   this.sizeFactors={small_hatchback:0.9,hatchback:1,sedan:1.1,luxury_sedan:1.21,four_by_four:1.331};
   this.get=(k)=>this.querySelector('[data-'+k+']');
   this.initColours();
   const make=this.get('make');
   const display=(v)=>v.split(' ').map(part=>part.length<4||/\d/.test(part)?part:part.charAt(0)+part.slice(1).toLowerCase()).join(' ');
   this.setupVehicleTypes();
   this.get('doors').value='4';this.get('shuts').value='4';
   make.addEventListener('change',()=>{
    if(this.isVan()){this.populateVanModels();return;}
    const model=this.get('model');model.replaceChildren(new Option(this.words.choose_model,''));
    const models=this.catalogue[make.value]||[];
    ['small_hatchback','hatchback','sedan','luxury_sedan','supercar','four_by_four','other'].forEach(band=>{
     const group=document.createElement('optgroup');group.label=band==='other'?this.words.category_other:this.words[band];
     models.filter(k=>(this.vehicleCategories[k]||'other')===band).forEach(k=>group.append(new Option(display(k.startsWith(make.value+' ')?k.slice(make.value.length+1):k),k)));
     if(group.children.length)model.append(group);
    });
    model.disabled=!this.catalogue[make.value];this.get('other-field').hidden=make.value!=='other';
    this.get('body').value='';this.get('year').value='';this.get('size-category').value='';this.bodyEdited=false;
   });
   this.get('model').addEventListener('change',()=>{this.bodyEdited=false;this.get('year').value='';if(this.isVan()){this.suggestVan();return;}this.suggestBody();});
   this.get('body').addEventListener('change',()=>{this.bodyEdited=true;});
   ['input','change'].forEach(event=>this.get('year').addEventListener(event,()=>{if(!this.isVan()&&!this.bodyEdited)this.suggestBody();}));
   this.get('doors').addEventListener('change',()=>{const s=this.get('shuts');const old=Number(s.value);s.replaceChildren();for(let i=1;i<=Number(this.get('doors').value);i++)s.add(new Option(String(i),String(i)));s.value=String(Math.min(old,Number(this.get('doors').value)));});
   this.addEventListener('input',()=>this.update());this.addEventListener('change',()=>this.update());
   this.querySelector('form').addEventListener('submit',e=>{this.update();if(!this.complete){e.preventDefault();this.get('make').focus();}});
   if(this.querySelector('form [role="status"],form .errors')){this.querySelector('.wc-enquiry').open=true;this.querySelector('.wc-disclosure').open=true;}
   const openFromHash=()=>{if(location.hash==='#wrap-calculator')this.querySelector('.wc-disclosure').open=true;};openFromHash();window.addEventListener('hashchange',openFromHash);this.openFromHash=openFromHash;
   this.update();
  }
  disconnectedCallback(){if(this.openFromHash)window.removeEventListener('hashchange',this.openFromHash);}

  isVan(){return this.get('vehicle-type').value==='van';}

  setupVehicleTypes(){
   this.vanCatalogue=JSON.parse(this.get('van-catalogue').textContent);
   this.vanPricing=JSON.parse(this.get('van-pricing').textContent);
   this.vanModels=new Map(Object.values(this.vanCatalogue).flat().map(m=>[m.id,m]));
   this.get('vehicle-type').addEventListener('change',()=>this.switchVehicleType());
   this.switchVehicleType();
  }

  switchVehicleType(){
   const van=this.isVan(),g=this.get,w=this.words;
   this.querySelectorAll('[data-car-only]').forEach(el=>{el.hidden=van;el.querySelectorAll('input,select').forEach(input=>input.disabled=van);});
   this.querySelectorAll('[data-van-only]').forEach(el=>{el.hidden=!van;el.querySelectorAll('input,select').forEach(input=>input.disabled=!van);});
   g('vehicle-intro').textContent=van?w.van_intro:w.intro;
   g('vehicle-legend').textContent=van?w.van_vehicle:w.vehicle;
   g('make').replaceChildren(new Option(w.choose_make,''));
   const display=v=>v.split(' ').map(part=>part.length<4||/\d/.test(part)?part:part.charAt(0)+part.slice(1).toLowerCase()).join(' ');
   Object.keys(van?this.vanCatalogue:this.catalogue).forEach(make=>g('make').add(new Option(van?make:display(make),make)));
   g('make').add(new Option(van?w.van_make_other:w.other,'other'));
   g('model').replaceChildren(new Option(w.choose_model,''));g('model').disabled=true;
   ['year','body','other-details','van-size','van-body','van-length','van-roof','van-details','van-car-body'].forEach(key=>g(key).value='');
   g('other-field').hidden=true;this.bodyEdited=false;
   g('contact-van-size').value='';g('contact-van-body').value='';g('contact-van-length').value='';g('contact-van-roof').value='';
   g('coverage').value='exterior';g('van-coverage').value='colour_change';g('shuts-field').hidden=true;
  }

  populateVanModels(){
   const g=this.get,w=this.pricingWords(),make=g('make').value,model=g('model');
   model.replaceChildren(new Option(w.choose_model,''));
   const models=this.vanCatalogue[make]||[];
   for(const size of ['car_derived','micro','small','medium','large','extra_large','other']){
    const group=document.createElement('optgroup');group.label=w['van_size_'+size];
    models.filter(row=>row.size===size).forEach(row=>group.append(new Option(row.name,row.id)));
    if(group.children.length)model.append(group);
   }
   if(models.length)model.add(new Option(w.van_model_other,'other'));
   model.disabled=!models.length;g('other-field').hidden=make!=='other';
   ['year','van-size','van-body','van-length','van-roof','van-details','van-car-body','other-details'].forEach(key=>g(key).value='');
  }

  suggestVan(){
   const g=this.get,m=this.vanModels.get(g('model').value);
   g('van-size').value=m?.size||'';g('van-body').value=m?.body||'';
   g('van-car-body').value=m?.size==='car_derived'?(/fiesta|corsa/i.test(m.name)?'car_small':/astra|escort|clubvan/i.test(m.name)?'car_estate':''):'';
   g('van-length').value='';g('van-roof').value='';g('van-details').value='';
   g('other-field').hidden=g('make').value!=='other'&&g('model').value!=='other';
  }

  vanPriceBand(){
   const g=this.get,size=g('van-size').value,length=g('van-length').value,roof=g('van-roof').value;
   if(!['panel','crew','kombi'].includes(g('van-body').value))return null;
   let key='';
   if(size==='car_derived'&&['short','medium'].includes(length)&&roof==='low')key=g('van-car-body').value;
   if(['small','medium'].includes(size)&&roof==='low'){
    if(['short','medium'].includes(length))key=size+'_standard';
    if(length==='long')key=size+'_long';
   }
   if(size==='large'&&length==='medium'&&roof==='medium')key='large_medium';
   if(size==='large'&&length==='long'&&roof==='high')key='large_long';
   if(['large','extra_large'].includes(size)&&length==='extra_long'&&roof==='high')key='large_extra_long';
   return this.vanPricing[key]?{key,...this.vanPricing[key]}:null;
  }

  updateVan(){
   const g=this.get,w=this.pricingWords(),make=g('make').value,m=this.vanModels.get(g('model').value);
   const custom=g('other-details').value.trim(),year=g('year').value;
   const other=make==='other'||g('model').value==='other';
   const chosen=!!(make&&(other?custom:m));
   const size=g('van-size').value,body=g('van-body').value,length=g('van-length').value,roof=g('van-roof').value;
   const derived=size==='car_derived',carBody=g('van-car-body').value;
   g('van-car-body-field').hidden=!derived;g('van-car-body').disabled=!derived;
   const label=(key,value)=>w['van_'+key+'_'+value]||'';
   const sizeName=label('size',size),bodyName=label('body',body);
   const category=[sizeName,bodyName,label('length',length),label('roof',roof),derived?label('car_body',carBody):''].filter(Boolean).join(' · ');
   const range=g('colour-source').value,rangeName=w['range_'+range]||w.range_other,c=this.selectedColour;
   const finish=c?rangeName+' — '+c.name+' ('+c.code+')':range==='other'?g('custom-colour').value.trim():'';
   const coverage=g('van-coverage').value,hasSize=!!(size&&body&&length&&roof&&(!derived||carBody));
   this.complete=chosen&&hasSize&&!!year&&g('year').checkValidity();
   g('size-category').value=category;g('size-label').textContent=category||w.van_choose_spec;
   g('size-note').textContent=w.van_size_note;g('body-note').textContent=w.van_body_note;
   g('installation-note').hidden=true;g('installation-note').textContent='';
   g('colour').value=finish;g('result-colour').hidden=!finish;g('result-colour').textContent=finish;
   g('result-category').hidden=!category;g('result-category').textContent=w.van_category+': '+category;
   g('contact-category').value=category;g('contact-range').value=rangeName;
   g('contact-colour').value=c?c.name:finish;g('contact-code').value=c?c.code:'';g('contact-product').value=c?c.url:'';
   g('contact-van-size').value=sizeName;g('contact-van-body').value=bodyName;
   g('contact-van-length').value=label('length',length);g('contact-van-roof').value=label('roof',roof);
   const band=this.vanPriceBand();
   const rates=this.colours.filter(colour=>!colour.specialist).map(colour=>colour.metrePrice).filter(price=>Number.isInteger(price)&&price>0);
   const rate=c?c.metrePrice:range!=='other'&&rates.length?Math.min(...rates):null;
   const withShuts=coverage==='with_shuts',exterior=coverage==='colour_change'||withShuts;
   const installationPriced=this.complete&&!!band&&exterior&&this.currency==='GBP'&&!g('condition').checked&&!c?.specialist;
   const priced=installationPriced&&Number.isInteger(rate)&&rate>0;
   const partial=installationPriced&&!priced;
   const showBreakdown=priced||partial,starting=priced&&!c;
   const material=priced?Math.round(band.metres*rate):0,labour=showBreakdown?band.labour+this.ppfVanLabour(band.key):0,total=material+labour;
   let price=w.quote_only;
   if(!this.complete)price=chosen?w.van_finish_spec:w.van_select_prompt;
   else if(priced)price=starting?w.from_price.replace('{price}',this.money(total)):this.money(total);
   else if(partial)price=w.partial_price.replace('{price}',this.money(labour));
   if(withShuts&&showBreakdown)price=w.van_exterior_estimate.replace('{price}',price);
   g('price').textContent=price;
   let note=!this.complete?'':this.currency!=='GBP'?w.currency_quote:showBreakdown?(partial?w.partial_note:w.vat):w.van_quote_note;
   if(showBreakdown&&withShuts)note+=' '+w.van_shuts_extra;
   g('price-note').textContent=note;g('disclaimer').textContent=showBreakdown?w.van_price_disclaimer:'';
   g('material-basis').hidden=!showBreakdown;
   g('material-basis').textContent=priced?w.material_basis.replace('{metres}',band.metres).replace('{price}',this.money(rate)):partial?w.partial_material_basis.replace('{metres}',band.metres):'';
   const breakdown=g('breakdown');breakdown.hidden=!showBreakdown;breakdown.replaceChildren();
   if(showBreakdown){
    const items=[[w.material,priced?this.money(material):w.quote_finish],[w.labour,this.money(labour)]];
    if(withShuts)items.push([w.van_shuts_label,w.quote_finish]);
    for(const [name,value] of items){const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=name;dd.textContent=value;row.append(dt,dd);breakdown.append(row);}
   }
   g('shuts-field').hidden=true;
   const vehicle=other?(make==='other'?custom:make+' / '+custom):make+' / '+(m?.name||'');
   const lines=[w.vehicle_type+': '+w.vehicle_van,vehicle+' / '+year,w.van_category+': '+category,w.van_details+': '+g('van-details').value.trim(),w.selected_colour+': '+(finish||w.colour_not_selected),w.coverage+': '+w['van_coverage_'+coverage],w.condition+': '+(g('condition').checked?w.yes:w.no)];
   if(showBreakdown){
    lines.push(w.vinyl_allowance+': '+w.metres.replace('{metres}',band.metres),w.material+': '+(priced?this.money(material):w.quote_finish),w.labour+': '+this.money(labour));
    if(priced)lines.push(w.unit_rate+': '+this.money(rate));
    lines.push((withShuts?w.van_exterior_label:w.estimated)+': '+price+' — '+w.vat,w.van_price_disclaimer);
    if(withShuts)lines.push(w.van_shuts_extra);
    if(partial)lines.push(w.partial_note);
   }else if(this.complete)lines.push(w.van_quote_note);
   g('summary').value=chosen?lines.join('\n'):'';g('submit').disabled=!this.complete;
   g('readiness').textContent=w.van_readiness;g('readiness').hidden=this.complete;
  }


  suggestBody(){
   const model=this.get('model').value,year=Number(this.get('year').value);
   const rule=(this.yearBodyRules[model]||[]).find(([from,to])=>year>=from&&year<=to);
   this.get('body').value=rule?rule[2]:this.vehicleBodies[model]||'';
  }

  money(pence) {
   return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:pence%100===0?0:2,maximumFractionDigits:2}).format(pence/100);
  }
  isPpf(){return this.get('colour-source').value.startsWith('ppf_');}
  pricingWords(){
   if(!this.isPpf())return this.words;
   const words={...this.words};
   for(const key of ['material','material_basis','partial_material_basis','partial_price','partial_note','vinyl_allowance','note','complexity_note','mpv_note'])words[key]=this.words['ppf_'+key];
   return words;
  }
  ppfLabour(body,premium=false){
   if(!this.isPpf())return 0;
   if(premium)return 70000;
   return {small_hatchback:40000,hatchback:40000,coupe:50000,convertible:50000,saloon:55000,estate:60000,compact_mpv:60000,luxury_saloon:70000,suv:70000,mpv:70000}[body]||0;
  }
  ppfVanLabour(key){
   if(!this.isPpf())return 0;
   return {car_small:40000,car_estate:60000,small_standard:60000,small_long:60000,medium_standard:65000,medium_long:65000,large_medium:70000,large_long:70000,large_extra_long:70000}[key]||0;
  }
  colourInfo(colour) {
   const name=colour.name.toLowerCase();
   const family=name.includes('flip')?'flip':name.startsWith('high gloss')?'high_gloss':name.includes('carbon')?'carbon':name.includes('brushed')?'brushed':name.startsWith('gloss')?'gloss':name.startsWith('satin')?'satin':/^(dead )?matt/.test(name)?'matt':'special';
   const metrePrice=Number.isInteger(colour.metrePrice)&&colour.metrePrice>0?colour.metrePrice:null;
   return {...colour,categories:Array.isArray(colour.categories)?colour.categories:[],family,metrePrice};
  }
  initColours() {
   this.colourPage=0;this.colourPageSize=12;this.selectedColour=null;
   this.colourCatalogues={};
   for(const [range,key] of [['3m','wrap-colours'],['avery','avery-colours'],['arlon','arlon-colours']]){
    try{this.colourCatalogues[range]=JSON.parse(this.get(key).textContent).map(c=>this.colourInfo({...c,range})).sort((a,b)=>a.name.localeCompare(b.name));}catch{this.colourCatalogues[range]=[];}
   }
   let ppf=[];
   try{ppf=JSON.parse(this.get('ppf-colours').textContent);}catch{ppf=[];}
   for(const range of ['ppf_3m','ppf_avery','ppf_arlon'])this.colourCatalogues[range]=ppf.filter(c=>c.range===range).map(c=>this.colourInfo(c)).sort((a,b)=>a.name.localeCompare(b.name));
   this.colours=this.colourCatalogues[this.get('colour-source').value]||[];
   const g=this.get;
   g('colour-browser').addEventListener('toggle',()=>{if(g('colour-browser').open)this.renderColours();});
   ['colour-search','colour-filter'].forEach(key=>g(key).addEventListener(key==='colour-search'?'input':'change',()=>{this.colourPage=0;this.renderColours();}));
   this.querySelectorAll('[data-finish-category]').forEach(button=>button.addEventListener('click',()=>{g('colour-filter').value=button.dataset.finishCategory;g('colour-search').value='';this.colourPage=0;this.renderColours();}));
   g('colour-prev').addEventListener('click',()=>{this.colourPage--;this.renderColours();});
   g('colour-next').addEventListener('click',()=>{this.colourPage++;this.renderColours();});
   g('clear-colour').addEventListener('click',()=>{this.selectedColour=null;g('colour-notice').textContent=this.words.colour_cleared;this.syncColour();this.update();g('colour-launch').focus();});
   g('colour-source').addEventListener('change',()=>{
    this.selectedColour=null;this.colourPage=0;this.colours=this.colourCatalogues[g('colour-source').value]||[];
    g('colour-filter').value='all';g('colour-search').value='';g('colour-notice').textContent='';g('colour-browser').open=false;this.syncColour();this.update();
   });
   for(const range of ['3m','avery','arlon','ppf_3m','ppf_avery','ppf_arlon'])g('colour-source').querySelector('option[value="'+range+'"]').disabled=!this.colourCatalogues[range].length;
   if(!this.colours.length){g('colour-source').value='other';g('colour-notice').textContent=this.words.no_catalogue;}
   this.syncColour();
  }
  renderColours() {
   const g=this.get,w=this.pricingWords();
   const clean=v=>v.toLowerCase().replace(/[^a-z0-9]/g,'');
   const term=clean(g('colour-search').value).replace(/^avery(dennison)?(supremewrap(ping)?film)?/,'').replace(/^arlon(premiumcolou?rchange(series)?)?/,'').replace(/^(3m)?2080/,''),filter=g('colour-filter').value;
   const exact=this.colours.filter(c=>clean(c.code)===term);
   const matches=(exact.length?exact:this.colours).filter(c=>(filter==='all'||c.categories.includes(filter))&&clean(c.name+' '+c.code).includes(term));
   this.colourPage=Math.max(0,Math.min(this.colourPage,Math.max(0,Math.ceil(matches.length/this.colourPageSize)-1)));
   this.querySelectorAll('[data-finish-category]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.finishCategory===filter)));
   const start=this.colourPage*this.colourPageSize,end=Math.min(start+this.colourPageSize,matches.length);
   g('colour-count').textContent=matches.length?w.colour_count.replace('{start}',start+1).replace('{end}',end).replace('{count}',matches.length):w.no_colours;
   g('colour-pager').hidden=matches.length<=this.colourPageSize;
   g('colour-prev').disabled=this.colourPage===0;g('colour-next').disabled=end>=matches.length;
   const grid=g('colour-grid');grid.replaceChildren();
   matches.slice(start,end).forEach(colour=>{
    const button=document.createElement('button');button.type='button';button.className='wc-swatch';button.setAttribute('aria-pressed',String(this.selectedColour?.code===colour.code));button.setAttribute('aria-label',colour.name+' — '+colour.code);
    const img=document.createElement('img');img.src=colour.image;img.alt='';img.width=160;img.height=160;img.loading='lazy';
    const name=document.createElement('strong'),code=document.createElement('small');name.textContent=colour.name;code.textContent=colour.code;button.append(img,name,code);
    const price=document.createElement('small');price.textContent=this.currency!=='GBP'?w.currency_quote:colour.metrePrice===null?w.quote_finish:w.per_metre.replace('{price}',this.money(colour.metrePrice));button.append(price);
    button.addEventListener('click',()=>{this.selectedColour=colour;g('colour-browser').open=false;g('colour-notice').textContent=w.colour_selected_notice.replace('{name}',colour.name+' ('+colour.code+')');this.syncColour();this.update();g('colour-launch').focus();});grid.append(button);
   });
  }
  syncColour() {
   const g=this.get,w=this.pricingWords(),c=this.selectedColour,isCatalogue=g('colour-source').value!=='other';
   g('catalogue-picker').hidden=!isCatalogue;g('custom-colour-field').hidden=isCatalogue;g('chosen-colour').hidden=!c;
   this.querySelectorAll('[data-finish-category]').forEach(button=>{const key=button.dataset.finishCategory;button.hidden=key!=='all'&&!this.colours.some(colour=>colour.categories.includes(key));});
   if(c){
    g('chosen-image').src=c.image;g('chosen-image').alt=c.name+' '+c.code;
    g('chosen-name').textContent=c.name;g('chosen-code').textContent=(w['range_'+c.range]||w.range_other)+' · '+c.code;
    g('chosen-tier').textContent=this.currency!=='GBP'?w.currency_quote:c.metrePrice===null?w.specialist_quote:w.per_metre.replace('{price}',this.money(c.metrePrice));
   }
  }

  update(){
   if(this.isVan()){this.updateVan();return;}
   this.get('readiness').textContent=this.words.car_readiness;
   const g=this.get,w=this.pricingWords();
   const make=g('make').value,model=g('model').value,body=g('body').value;
   const bodyBand=this.bodyBands[body]||'';
   const isRolls=make.replace(/[^A-Z0-9]/g,'')==='ROLLSROYCE';
   const isSupercar=this.vehicleCategories[model]==='supercar';
   const premium=isRolls||isSupercar;
   const band=bodyBand?(isRolls?'luxury_sedan':isSupercar?'supercar':bodyBand):'';
   g('size-category').value=band;
   const year=g('year').value,custom=g('other-details').value.trim();
   const full=g('coverage').value==='full',doors=Number(g('shuts').value);
   const colour=this.selectedColour,range=g('colour-source').value,isCatalogue=range!=='other',rangeName=w['range_'+range]||w.range_other;
   const factor=this.sizeFactors[bodyBand];
   g('size-label').textContent=band?w.body_price.replace('{category}',w[band]):w.body_prompt;
   g('size-note').textContent=band?(isRolls?w.rolls_example:w[band+'_example']):'';
   g('installation-note').hidden=!premium||!band;
   g('installation-note').textContent=premium?w.complexity_note:'';
   g('body-note').textContent=(body==='compact_mpv'||body==='mpv'?w.mpv_note+' ':'')+w.body_note;
   g('colour').value=colour?rangeName+' — '+colour.name+' ('+colour.code+')':!isCatalogue?g('custom-colour').value.trim():'';
   g('result-colour').hidden=!g('colour').value;g('result-colour').textContent=g('colour').value;
   g('result-category').hidden=!band;g('result-category').textContent=w.size_category+': '+(w[band]||'');
   g('contact-category').value=w[band]||'';
   g('contact-range').value=rangeName;
   g('contact-colour').value=colour?colour.name:g('colour').value;g('contact-code').value=colour?colour.code:'';g('contact-product').value=colour?colour.url:'';
   const selected=!!(make&&(make==='other'?custom:model)&&body);
   this.complete=selected&&!!year&&g('year').checkValidity();
   const availableRates=this.colours.filter(c=>!c.specialist).map(c=>c.metrePrice).filter(p=>p!==null);
   const rate=colour?colour.metrePrice:isCatalogue&&availableRates.length?Math.min(...availableRates):null;
   const starting=!colour&&isCatalogue;
   const metres=this.materialMetres[body];
   const installationPriced=selected&&!!factor&&!!metres&&this.currency==='GBP'&&!g('condition').checked&&!colour?.specialist;
   const priced=installationPriced&&rate!==null;
   const partial=installationPriced&&!!colour&&rate===null;
   const showBreakdown=priced||partial;
   const material=priced?Math.round(metres*rate):0;
   const baseLabour=Math.round(163690*(premium?this.sizeFactors.luxury_sedan:factor));
   const complexityPremium=premium?Math.round(baseLabour*0.20):0;
   const labour=baseLabour+complexityPremium+this.ppfLabour(body,premium);
   const displayLabour=this.isPpf()?labour:baseLabour,displayComplexity=this.isPpf()?0:complexityPremium;
   const doorCost=full?doors*25000:0,deep=full?50000:0,installationSubtotal=labour+doorCost+deep,total=material+installationSubtotal;
   g('shuts-field').hidden=!full;
   g('price').textContent=!selected?w.select_prompt:priced?(starting?w.from_price.replace('{price}',this.money(total)):this.money(total)):partial?w.partial_price.replace('{price}',this.money(installationSubtotal)):w.quote_only;
   g('price-note').textContent=!selected?'':!factor?w.quote_reason:this.currency!=='GBP'?w.currency_quote:priced?(starting?w.starting_note:w.vat):partial?w.partial_note:colour&&rate===null?w.specialist_quote:w.quote_reason;
   g('disclaimer').textContent=showBreakdown?w.note:'';
   g('material-basis').hidden=!showBreakdown;
   g('material-basis').textContent=priced?w.material_basis.replace('{metres}',metres).replace('{price}',this.money(rate)):partial?w.partial_material_basis.replace('{metres}',metres):'';
   const breakdown=g('breakdown');breakdown.hidden=!showBreakdown;breakdown.replaceChildren();
   if(showBreakdown)[[w.material,priced?material:w.quote_finish],[w.labour,displayLabour],[w.complexity_premium,displayComplexity],[w.door_cost,doorCost],[w.deep,deep]].forEach(([label,value])=>{if(value){const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=typeof value==='number'?this.money(value):value;row.append(dt,dd);breakdown.append(row);}});
   const lines=[(make==='other'?custom:make+' / '+model)+' / '+year,w.size_category+': '+(w[band]||''),body?w.body+': '+w[body]:'',w.doors+': '+g('doors').value,w.selected_colour+': '+(g('colour').value||w.colour_not_selected),w.coverage+': '+(full?w.full+' ('+doors+')':w.exterior),w.condition+': '+(g('condition').checked?w.yes:w.no)];
   if(priced)lines.push(w.vinyl_allowance+': '+w.metres.replace('{metres}',metres),w.unit_rate+': '+this.money(rate),w.material+': '+this.money(material),w.labour+': '+this.money(displayLabour),...(displayComplexity?[w.complexity_premium+': '+this.money(displayComplexity)]:[]),w.door_cost+': '+this.money(doorCost),w.deep+': '+this.money(deep),w.estimated+': '+(starting?w.from_price.replace('{price}',this.money(total)):this.money(total))+' — '+w.vat);
   else if(partial)lines.push(w.vinyl_allowance+': '+w.metres.replace('{metres}',metres),w.material+': '+w.quote_finish,w.labour+': '+this.money(displayLabour),...(displayComplexity?[w.complexity_premium+': '+this.money(displayComplexity)]:[]),w.door_cost+': '+this.money(doorCost),w.deep+': '+this.money(deep),w.installation_subtotal+': '+this.money(installationSubtotal)+' — '+w.vat,w.estimated+': '+w.quote_finish,w.partial_note);
   else lines.push(w.custom);
   if(premium)lines.push(w.complexity_note);
   g('summary').value=selected?lines.filter(Boolean).join('\n'):'';g('submit').disabled=!this.complete;g('readiness').hidden=this.complete;
  }

 }
 customElements.define('wrap-price-calculator',WrapPriceCalculator);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrap-recent-work"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wrap-recent-work')) {
    customElements.define('wrap-recent-work', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.events = new AbortController();
        this.request = new AbortController();
        this.slidesHost = this.querySelector('.wt-recent__slides');
        this.controls = this.querySelector('.wt-recent__controls');
        this.status = this.querySelector('.wt-recent__status');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches || this.dataset.designMode === 'true';
        this.inView = false;
        this.hovered = false;
        this.focused = false;
        this.ready = false;
        const opts = { signal: this.events.signal };
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-action]');
          if (!button || !this.ready) return;
          if (button.dataset.action === 'pause') {
            this.paused = !this.paused;
            this.updatePause();
          } else this.show(this.index + (button.dataset.action === 'next' ? 1 : -1), true);
          this.schedule();
        }, opts);
        this.addEventListener('keydown', event => {
          if (!this.ready || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          this.schedule();
        }, opts);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, opts);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, opts);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, opts);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, opts);
        this.slidesHost.addEventListener('pointerdown', event => {
          if (event.pointerType === 'touch') this.touch = { x: event.clientX, y: event.clientY };
        }, opts);
        this.slidesHost.addEventListener('pointerup', event => {
          if (!this.touch || !this.ready) return;
          const dx = event.clientX - this.touch.x;
          const dy = event.clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.show(this.index + (dx < 0 ? 1 : -1), true);
            this.schedule();
          }
        }, opts);
        this.slidesHost.addEventListener('pointercancel', () => { this.touch = null; }, opts);
        document.addEventListener('visibilitychange', () => this.schedule(), opts);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.updatePause(); this.schedule(); }, opts);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (this.inView && !this.loading) { this.loading = true; this.loadGallery(); }
          this.schedule();
        }, { threshold: .1 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.fetchTimer);
        this.events?.abort();
        this.request?.abort();
        this.observer?.disconnect();
        this.started = false;
        this.loading = false;
      }
      async loadGallery() {
        try {
          const url = new URL(this.dataset.galleryUrl, location.origin);
          if (url.origin !== location.origin) throw new Error('Gallery must use the store domain');
          this.fetchTimer = setTimeout(() => this.request.abort(), 7000);
          const response = await fetch(url.href, { credentials: 'same-origin', signal: this.request.signal });
          if (!response.ok) throw new Error('Gallery unavailable');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const cards = [...page.querySelectorAll('main .multicolumn-card')];
          const unique = new Set();
          const slides = [];
          for (const card of cards) {
            const img = card.querySelector('img');
            const heading = card.querySelector('h3');
            if (!img || !heading || !img.getAttribute('src')) continue;
            const source = new URL(img.getAttribute('src'), url);
            if (!['https:', 'http:'].includes(source.protocol) || unique.has(source.pathname)) continue;
            unique.add(source.pathname);
            const slide = document.createElement('article');
            slide.className = 'wt-recent__slide';
            const media = document.createElement('a');
            media.className = 'wt-recent__image-link';
            media.href = url.pathname + url.search;
            media.tabIndex = -1;
            media.setAttribute('aria-hidden', 'true');
            const image = document.createElement('img');
            image.className = 'wt-recent__image';
            image.src = source.href;
            image.alt = img.alt || heading.textContent.trim();
            for (const attribute of ['srcset', 'width', 'height']) {
              if (img.hasAttribute(attribute)) image.setAttribute(attribute, img.getAttribute(attribute));
            }
            image.sizes = '(min-width: 1100px) 1000px, calc(100vw - 40px)';
            image.loading = 'lazy';
            media.append(image);
            const info = document.createElement('div');
            info.className = 'wt-recent__info';
            const title = document.createElement('h3');
            title.className = 'h2';
            const link = document.createElement('a');
            link.href = media.href;
            link.textContent = heading.textContent.trim();
            title.append(link);
            const description = document.createElement('p');
            description.className = 'wt-recent__description';
            description.textContent = card.querySelector('.rte')?.textContent.trim() || '';
            info.append(title, description);
            slide.append(media, info);
            slides.push(slide);
            if (slides.length >= Number(this.dataset.limit)) break;
          }
          if (slides.length && this.isConnected) this.slidesHost.replaceChildren(...slides);
        } catch (_) {
        } finally {
          clearTimeout(this.fetchTimer);
          if (this.isConnected) this.start();
        }
      }
      start() {
        this.slides = [...this.slidesHost.querySelectorAll('.wt-recent__slide')];
        if (!this.slides.length) return;
        for (let i = this.slides.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [this.slides[i], this.slides[j]] = [this.slides[j], this.slides[i]];
        }
        this.slidesHost.replaceChildren(...this.slides);
        this.ready = true;
        this.controls.hidden = this.slides.length < 2;
        this.show(0, false);
        this.updatePause();
        this.schedule();
      }
      show(index, announce) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          slide.hidden = i !== this.index;
          slide.classList.toggle('wt-recent__slide--enter', i === this.index);
        });
        const current = this.slides[this.index];
        current.querySelector('img')?.setAttribute('loading', 'eager');
        this.slides[(this.index + 1) % this.slides.length].querySelector('img')?.setAttribute('loading', 'eager');
        this.querySelector('.wt-recent__count').textContent = `${this.index + 1} / ${this.slides.length}`;
        if (announce) this.status.textContent = this.dataset.position.replace('[current]', this.index + 1).replace('[total]', this.slides.length) + ': ' + current.querySelector('h3').textContent;
      }
      updatePause() {
        const button = this.querySelector('[data-action="pause"]');
        button.textContent = this.paused ? this.dataset.play : this.dataset.pause;
        button.setAttribute('aria-pressed', String(this.paused));
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.ready || this.slides.length < 2 || this.paused || this.hovered || this.focused || !this.inView || document.hidden) return;
        this.timer = setTimeout(() => { this.show(this.index + 1, false); this.schedule(); }, Number(this.dataset.interval) || 6000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-project-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wt-project-gallery')) {
    customElements.define('wt-project-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.querySelectorAll('[data-photo]').forEach(link => {
          link.addEventListener('click', event => {
            if (!this.dialog.showModal || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.returnFocus = link;
            const card = link.closest('[data-project]');
            this.photos = Array.from(card.querySelectorAll('[data-photo]'));
            this.index = this.photos.indexOf(link);
            this.querySelector('[data-dialog-title]').textContent = card.dataset.project;
            this.showPhoto();
            this.dialog.showModal();
            this.querySelector('[data-close]').focus();
          });
        });
        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
        this.querySelector('[data-previous]').addEventListener('click', () => this.move(-1));
        this.querySelector('[data-next]').addEventListener('click', () => this.move(1));
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(event.key === 'ArrowLeft' ? -1 : 1);
          }
        });
        this.dialog.addEventListener('click', event => {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.returnFocus?.focus());
      }
      move(direction) {
        this.index = (this.index + direction + this.photos.length) % this.photos.length;
        this.showPhoto();
      }
      showPhoto() {
        const link = this.photos[this.index];
        const image = new Image();
        image.src = link.href;
        image.alt = link.querySelector('img').alt;
        image.width = 2000;
        image.height = 1400;
        this.querySelector('[data-full-image]').replaceChildren(image);
        this.querySelector('[data-count]').textContent = `${this.index + 1} / ${this.photos.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
